import { Utils } from "../utilities/Utils";
import { mapData } from '@/utilities/DataMapping';

export interface IContractorDefaultScanTimes {
    id: number;
    guid: string;
    scanInEarliestDifference: number;
    scanInLatestDifference: number;
    scanOutEarliestDifference: number;
    scanOutLatestDifference: number;
    scanDefaultsChangedByUserID: number;
    scanDefaultStayDuration: number;
}

export class ContractorDefaultScanTimes implements IContractorDefaultScanTimes {

    constructor(data?: IContractorDefaultScanTimes) {
        if (typeof data === "undefined" || data === null) return;
        this.update(data);
    }

    update(data: IContractorDefaultScanTimes) {
        mapData(data, {
            root: () => this
        });
    }

    id: number = 0;
    guid: string = Utils.emptyGuidValue;
    scanInEarliestDifference: number = 0;
    scanInLatestDifference: number = 0;
    scanOutEarliestDifference: number = 0;
    scanOutLatestDifference: number = 0;
    scanDefaultsChangedByUserID: number = 0;
    scanDefaultStayDuration: number = 0;

    get isNew() {
        return Utils.isEmptyId(this.id);
    }
}